module.exports = __webpack_public_path__ + "a623285155621a2bb93e2b4b4197d066.MP3";